import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { hourMinute } from 'sc-intl/dist/dateTimeFormatters';
import { getNextAvailableEventTodayTime } from '../selectors/eventSeries';

const MINUTES_THRESHHOLD = 60;

class NextAvailableTime extends Component {

    render() {
        if (!this.props.nextAvailableEventTime || !this.props.isRecurring) {
            return null;
        }

        const diffms = this.props.nextAvailableEventTime.getTime() - this.props.currentTime.getTime();
        if (diffms > 0) {
            const minutes = Math.ceil((diffms / 1000) / 60);
            if (minutes < MINUTES_THRESHHOLD) {
                return <span className="next-avaliable-time">Next available in {minutes === 0 ? "1" : minutes} {minutes === 1 ? 'minute' : 'minutes'}</span>
            }
        }

        return (
            <span className="next-avaliable-time">Next available at {hourMinute(this.props.locale, this.props.nextAvailableEventTime)}</span>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        locale: state.intl.locale,
        nextAvailableEventTime: getNextAvailableEventTodayTime(state),
        isRecurring: Object.values(state.event.events)[0].event.isRecurring ? true : false,
        currentTime: state.time.currentTime,
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
    }, dispatch);
};

NextAvailableTime.propTypes = {
};

export default connect(mapStateToProps, mapDispatchToProps)(NextAvailableTime)
